"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

/**
 * Mission Ready label — silver, uppercase, tracking-wider for tactical section
 * labels. Default variant covers form field labels app-wide.
 */
const labelVariants = cva(
  "text-[11px] font-semibold uppercase tracking-[0.14em] text-[#C0C0C0] leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      tone: {
        default: "",
        plain: "text-sm font-medium normal-case tracking-normal text-foreground",
      },
    },
    defaultVariants: { tone: "default" },
  },
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, tone, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ tone }), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
